import WithProposalContainer from '../Common/WithProposalContainer'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { PROPOSAL_TYPE_NAME } from '../../constants/proposalTypes'
import BatchUpdateImageOverview from '../../components/BatchProposal/BatchUpdateImage/Overview'

BatchUpdateImageOverview.fetchData = async ({
  store,
  req,
  res,
  match
}) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const proposalType = PROPOSAL_TYPE.UPDATE_IMAGE

const props = {
  proposalType,
  proposalTypeName: PROPOSAL_TYPE_NAME[proposalType]
}

const MappedContainer = WithProposalContainer(BatchUpdateImageOverview, props)

export default MappedContainer
